import React, { useEffect, useState } from 'react';
import { getHardOffers, OffersTypes } from './query/offers';
import CustomModal from '../Modals';
import PaymentModal from './PaymentModal';

interface HardOffersProps {
  updateRubies: (rubies: number) => void;
}

export default function HardOffers({ updateRubies }: HardOffersProps) {
  const [open, setOpen] = useState(false);
  const [hardOffers, setHardOffers] = useState<OffersTypes[]>([]);
  const [selectedOffer, setSelectedOffer] = useState<OffersTypes | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchHardOffers();
  }, []);

  async function fetchHardOffers() {
    setLoading(true);
    try {
      const hardData = await getHardOffers();
      setHardOffers(hardData);
    } catch (error) {
      setError(error);
    } finally {
      setLoading(false);
    }
  }

  if (loading) return <h1 className='text-white font-chakra'>Loading...</h1>;
  if (error)
    return <h1 className='text-red font-anton'>Something went wrong...</h1>;

  function toggleOpen(item) {
    setOpen((open) => !open);
    setSelectedOffer(item);
  }

  function closeModal() {
    setOpen(false);
  }

  return (
    <>
      <div className='buy-container'>
        {hardOffers.map((item: OffersTypes) => {
          return (
            <div
              key={item.id}
              className='buy-container-content relative overflow-hidden'
              style={{
                borderRight: '1px solid #1B062F',
                height: '141px',
              }}
            >
              {item.discount && (
                <div className='absolute p-[2px] text-[12px] w-[120px] bg-green top-[15px] right-[-40px] rotate-[45deg] text-center text-[#1B062F]'>
                  SAVE: {item.discount}
                </div>
              )}
              <p className='text-red font-anton font-[400] font-[16px]'>
                x{item.receive_amount}
              </p>
              <img
                className='w-[37px] h-[23px]'
                src='../img/public/rubin_sm.png'
              />
              <p className='text-main font-[400] font-anton text-[16px]'>
                ₹{item.pay_amount}
              </p>
              <button
                onClick={() => toggleOpen(item)}
                className='buy-rubies-btn font-anton'
                style={{
                  width: '90px',
                  height: '40px',
                  backgroundColor: '#F73261',
                  color: '#1B062F',
                  fontWeight: '400',
                  textAlign: 'center',
                }}
              >
                BUY
              </button>
              <CustomModal
                isOpen={open}
                onRequestClose={toggleOpen}
                contentLabel='BUY'
                children={
                  selectedOffer && (
                    <PaymentModal
                      receiveAmount={selectedOffer.receive_amount}
                      payAmount={selectedOffer.pay_amount}
                      offerId={selectedOffer.id}
                      updateRubies={updateRubies}
                      closeModal={closeModal}
                      offerType={selectedOffer.offer_type}
                    />
                  )
                }
              />
            </div>
          );
        })}
      </div>
    </>
  );
}
